export const PERMISSION_RESOURCE_CODES = {
  permission: 'permission',
} as const;

export const PERMISSION_ACTION_CODES = {
  permission: {},
};
